import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import Seo from "./components/Seo";
import CookieBanner from "./components/CookieBanner";
import { Toaster } from "./components/ui/toaster";

import Home from "./pages/Home";
import About from "./pages/About";
import Fagentreprise from "./pages/Fagentreprise";
import SegmentPage from "./pages/SegmentPage";
import Documentation from "./pages/Documentation";
import Contact from "./pages/Contact";
import LegalPage from "./pages/LegalPage";
import { privacyPolicy, cookiePolicy } from "./legal";
import { assetManagersPage, contractorsPage } from "./mock";

function App() {
  return (
    <div className="App min-h-screen bg-bone">
      <BrowserRouter>
        <ScrollToTop />
        <Seo />
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/om-kepp" element={<About />} />
            <Route path="/fagentreprise" element={<Fagentreprise />} />
            <Route path="/asset-managers" element={<SegmentPage data={assetManagersPage} />} />
            <Route path="/hovedentreprenorer" element={<SegmentPage data={contractorsPage} />} />
            <Route path="/dokumentation-kvalitet" element={<Documentation />} />
            <Route path="/kontakt" element={<Contact />} />
            <Route path="/privatlivspolitik" element={<LegalPage data={privacyPolicy} />} />
            <Route path="/cookiepolitik" element={<LegalPage data={cookiePolicy} />} />
          </Routes>
        </main>
        <Footer />
        <Toaster />
        <CookieBanner />
      </BrowserRouter>
    </div>
  );
}

export default App;
